import $ from 'jquery'

export default class CommonForm {
  constructor(props) {
    this.elm = document.querySelector(props.target)
  }

  init() {
    if (this.elm) {
      $(function() {
        $(".c-input-checkbox input[type='checkbox']").change(function() {
          var ischecked = $(this).is(":checked");

          console.log( $(this));
          if(ischecked) {
            console.log('s');
            $('.js-btn-submit').removeClass('-is-disable').addClass('-blue')
          } else {
            console.log('a');
            $('.js-btn-submit').removeClass('-blue').addClass('-is-disable')
          }
        });
      })
    }
  }
}



